var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"chatter-button-container",on:{"click":function($event){return _vm.$emit('onClick')}}},[_c(_setup.Icon,{attrs:{"name":"badge_holder_chatter_icon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }